<template lang="pug">
.a_2_upperContent
    VidUtil(
        :src="vids[current]"
        :loop="loop[current]"
        width="3840"
        height="700"
        duration="1"
        :endCallBack="vidEnded"
    )
</template>

<script>
import SocketService from '@/services/SocketService'
import VidUtil from '@/utils/VidUtil'
import KeyService from '@/services/KeyService'
const basePath = './static/A/A_2/upper/'
export default {
    components:{
        VidUtil
    },
    data(){
        return {
            //用到的视频
            vids:[
                `${basePath}1.mp4`, //0
                `${basePath}1.5.mp4`,//1
                `${basePath}2.mp4`,//2
                `${basePath}tmp/2-1.mp4`,//3
                `${basePath}tmp/2-2.mp4`,//4
                `${basePath}tmp/3-1.mp4`,//5
                `${basePath}tmp/3-2.mp4`,//6
            ],
            //是否循环
            loop:[
                true,
                false,
                true,
            ],
            current: 0
        }
    },
    mounted(){
        KeyService.getInstance().n.add(this.next.bind(this))
        SocketService.getInstance().getSocket().on('a',data=>{
            if(data.type && data.type === 'state0'){
                if(data.event === 'update'){
                    this.current = 1
                }
                if(data.event === 'reset'){
                    this.current = 0
                }
            }else if(data.type && data.type === 'state1'){
                if(data.event === 'update'){
                    this.current = 4
                }
                if(data.event === 'reset'){
                    this.current = 3
                }
            }else if(data.type && data.type === 'state2'){
                if(data.event === 'update'){
                    this.current = 6
                }
                if(data.event === 'reset'){
                    this.current = 5
                }
            }
        })
    },
    methods:{
        next(){
            this.current = (this.current +1)%this.vids.length
        },
        vidEnded(){
            console.log('ended',this.current)
            this.current = (this.current+1)%this.vids.length

        }
    }

}
</script>

<style lang="sass" scoped>
@import '@/styles/common'
.a_2_upperContent
    position: absolute
    bottom: 0
    left: 0
    width: pxToRem(3840)
    height: pxToRem(700)
    background: #ff0000

</style>